import { PrivateRouteProps } from 'enums/PrivateRouteEnums';

/**
 * Custom hook to get the current user's role from localStorage
 * 
 * Note: This is a simple synchronous read from localStorage.
 * Since localStorage is synchronous and fast, no memoization is needed.
 * The role is read fresh on each render to ensure consistency.
 * 
 * @returns The user's role string (e.g., "Super Admin", "Admin", "Data Contributor", "Viewer") or undefined
 * 
 * @example
 * const userRole = useUserRole();
 * const canCreateItem = canCreate(userRole);
 */
export const useUserRole = (): string | undefined => {
  try {
    const userDetails = localStorage.getItem(PrivateRouteProps.USER)
      ? JSON.parse(localStorage.getItem('userDetails') ?? '{}')
      : null;
    return userDetails?.role;
  } catch (error) {
    console.error('Error parsing user details:', error);
    return undefined;
  }
};
